import React, {useState} from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, {dateFilter, textFilter, numberFilter, Comparator} from 'react-bootstrap-table2-filter';
import ToolkitProvider, {ColumnToggle} from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Moment from "moment";

// at December 9th, 2020, Metalac decided to allow only one stamp per day.
const whenNewLogicForStampsApplied = new Date(2020, 11, 9);
// One day in milliseconds
const oneDayInMilliseconds = 1000 * 60 * 60 * 24;

const MyExportCSV = (props) => {
    const handleClick = () => {
        props.onExport();
    };
    return (
        <div className="col-md-4 center">
            <button className="btn btn-success" onClick={handleClick}>Export Visible Data To File</button>
        </div>
    );
};

const {ToggleList} = ColumnToggle;

let scanDateRangeConst = {};

export const Bonus = ({scans, bonusForCompare, scanDateRange, page, setPage, filter, setFilter, firebase = null, useUID = null}) => {
    const columns = [{
        dataField: 'index',
        text: 'Index',
        sort: true
    }, {
        dataField: 'uid',
        text: 'Uid',
        filter: textFilter({
            defaultValue: filter instanceof Map && filter.has("uid") ? filter.get("uid") : '',
            onFilter: (filterValue) => {
                setFilter("uid", filterValue)
            }
        }),
        sort: true
    }, {
        dataField: 'totalValue',
        text: 'Total',
        filter: numberFilter({
            defaultValue: filter instanceof Map && filter.has("totalValue") ? filter.get("totalValue") : {
                number: 0,
                comparator: Comparator.GT
            },
            onFilter: (filterValue) => {
                setFilter("totalValue", filterValue)
            }
        }),
        sort: true
    }, {
        dataField: 'valueInLastBonusPeriod',
        text: 'Value in Bonus Period',
        filter: numberFilter({
            defaultValue: {number: 0, comparator: Comparator.GT}
        }),
        sort: true
    }, {
        dataField: 'valueInLastBonusPeriodShouldBe',
        text: 'Should be',
        filter: numberFilter({
            defaultValue: filter instanceof Map && filter.has("valueInLastBonusPeriodShouldBe") ? filter.get("valueInLastBonusPeriodShouldBe") : {
                number: 0,
                comparator: Comparator.GT
            },
            onFilter: (filterValue) => {
                setFilter("valueInLastBonusPeriodShouldBe", filterValue)
            }
        }),
        sort: true
    }, {
        dataField: 'visits',
        text: 'Visits',
        filter: numberFilter({
            defaultValue: {number: 0, comparator: Comparator.GT}
        }),
        hidden: false,
        sort: true
    }, {
        dataField: 'uidForScanFrequency',
        text: 'Scan Frequency',
        filter: numberFilter({
            defaultValue: {comparator: Comparator.GT}
        }),
        filterValue: scanFrequencyFormatter,
        sortValue: scanFrequencyFormatter,
        formatter: scanFrequencyFormatter,
        csvFormatter: scanFrequencyFormatter,
        sort: true
    }, {
        dataField: 'city',
        text: 'City',
        sort: true,
        hidden: true,
        filter: textFilter()
    }, {
        dataField: 'storeId',
        text: 'Store Id',
        sort: true,
        filter: textFilter(),
        hidden: true,
    }, {
        dataField: 'time',
        hidden: false,
        sort: true,
        text: 'Time'
    }, {
        dataField: 'timestamp',
        text: 'Date',
        filter: dateFilter({
            defaultValue: filter instanceof Map && filter.has("timestamp") ? filter.get("timestamp") : {},
            onFilter: (filterValue) => {
                setFilter("timestamp", filterValue)
            }
        }),
        formatter: dateFormatter,
        csvFormatter: dateFormatter,
        sort: true
    }, {
        dataField: 'timestamp1',
        text: 'Date Again',
        filter: dateFilter({
            defaultValue: filter instanceof Map && filter.has("timestamp1") ? filter.get("timestamp1") : {},
            onFilter: (filterValue) => {
                setFilter("timestamp1", filterValue)
            }
        }),
        formatter: dateFormatter,
        csvFormatter: dateFormatter,
        sort: true
    }];

    function dateFormatter(cell, row) {
        return Moment.tz(cell, 'Europe/Belgrade').format('DD.MM.YYYY');
    }

    function scanFrequencyFormatter(cell, row) {
        if (typeof scanDateRangeConst[cell] === "undefined") {
            return -1;
        }
        const diffInTime = scanDateRangeConst[cell].endTime.toDate().getTime() - scanDateRangeConst[cell].startTime.toDate().getTime();
        const diffInDays = Math.round(diffInTime / oneDayInMilliseconds) + 1;
        return Math.round((scanDateRangeConst[cell].visitCount / diffInDays) * 1000) / 1000;
    }

    scanDateRangeConst = scanDateRange;
    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            // alert("Row index: " + (rowIndex + 1));
        }
    };

    let bonusUid = new Map();
    let bonusExistUid = new Map();
    if (bonusForCompare != null) {
        bonusUid = bonusForCompare.reduce((map, bonus) => {
            map.set(bonus.uid + "_" + bonus.date, bonus.valueInLastBonusPeriod);
            return map;
        }, new Map());

        bonusForCompare.forEach(bonus => {
            bonusExistUid.set(bonus.uid, "exist");
        })
    }

    let lastTimeBonus = new Map();
    scans.forEach(scan => {
        if (lastTimeBonus.has(scan.uid)) {
            if (lastTimeBonus.get(scan.uid) < scan.timestamp) {
                lastTimeBonus.set(scan.uid, scan.timestamp);
            }
        } else {
            lastTimeBonus.set(scan.uid, scan.timestamp);
        }
    })

    const millisToMinutesAndSeconds = (millis) => {
        if(millis < 0) {
            let newMillis = -millis;
            let minutes = Math.floor(newMillis / 60000);
            let seconds = ((newMillis % 60000) / 1000).toFixed(0);
            return "-" + minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
        }
        let minutes = Math.floor(millis / 60000);
        let seconds = ((millis % 60000) / 1000).toFixed(0);
        return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
    }

    scans.forEach((scan, index) => {
        if (bonusUid.has(scan.uid + "_" + scan.date)
            && bonusUid.get(scan.uid + "_" + scan.date) !== scan.valueInLastBonusPeriod) {
            return scan.valueInLastBonusPeriodShouldBe = bonusUid.get(scan.uid + "_" + scan.date);
        } else if (!bonusUid.has(scan.uid + "_" + scan.date)) {
            // if (lastTimeBonus.has(scan.uid) && lastTimeBonus.get(scan.uid) === scan.timestamp && bonusExistUid.has(scan.uid)) {
            //     // last bonus in history and there is some info in bonus events, but not the last one.
            //     // this is not good, because the wrong value will be used for lastBonusValue
            //     return scan.valueInLastBonusPeriodShouldBe = -402;
            //     // this case should be added to bonus event table
            // } else if (lastTimeBonus.has(scan.uid) && lastTimeBonus.get(scan.uid) === scan.timestamp) {
            //     // last bonus in history and there is no info in bonus events.
            //     // This is fine, because for the calculation will be used value from history
            //     return scan.valueInLastBonusPeriodShouldBe = -403;
            // } else {
            //     // bonus is missing
            //     // this is also fine, the bonus from history will be used for next bonus
            //     return scan.valueInLastBonusPeriodShouldBe = -404;
            // }
        }
        let timeDiffForBonus = scan.timeForInsert.toDate() - scan.lastVisit.toDate();
        if(timeDiffForBonus > 5 * 60 * 1000) {
            return scan.valueInLastBonusPeriodShouldBe = millisToMinutesAndSeconds(timeDiffForBonus);
        }
    }, scans);

    const rowStyle = (scan) => {
        if (bonusForCompare == null) {
            return {backgroundColor: ''};
        }
        if (!bonusUid.has(scan.uid + "_" + scan.date)) {
            return {backgroundColor: '#be508f'};
        } else if (bonusUid.has(scan.uid + "_" + scan.date)
            && bonusUid.get(scan.uid + "_" + scan.date) !== scan.valueInLastBonusPeriod) {
            return {backgroundColor: '#ffda90'};
        } else {
            return {backgroundColor: ''};
        }
    };

    const onPageChange = (num) => {
        setPage(num);
    }

    const options = {
        page: page,
        sizePerPageList: [{text: '50', value: 50}, {text: '100', value: 100}, {text: '250', value: 250}, {
            text: 'All',
            value: scans.length
        }],
        onPageChange: onPageChange,
        showTotal: true
    }

    return (
        <ToolkitProvider
            keyField='index'
            data={scans}
            columns={columns}
            columnToggle
            pagination={paginationFactory(options)}
            exportCSV={{
                exportAll: false,
                onlyExportFiltered: true
            }}>
            {props => (
                <div>
                    <hr/>
                    <MyExportCSV {...props.csvProps}/>
                    <hr/>
                    <ToggleList {...props.columnToggleProps} />
                    <hr/>
                    <BootstrapTable striped bordered hover {...props.baseProps}
                                    pagination={paginationFactory(options)}
                                    rowStyle={rowStyle}
                                    rowEvents={rowEvents}
                                    bootstrap4={true}
                                    tabIndexCell
                                    filter={filterFactory()}
                    />
                </div>
            )
            }
        </ToolkitProvider>
    )
}